const en = {
  username: 'Username', name: 'Name', photo: 'Photo', language: 'Language', location: 'Location',
  country: 'Country', chooseCountry: 'Choose a country',
  useLocation: 'Use my location', locating: 'Determining location…',
  locationDenied: 'Location access is denied. Choose a country from the list.',
  locationUnavailable: 'Could not determine your location. Choose a country from the list.',
  locationNotFound: 'Could not determine your country. Choose one from the list.',
  countrySearch: 'Find a country', noCountries: 'No countries found',
  notifications: 'Notifications', likes: 'Likes', reposts: 'Reposts', subscriptions: 'New followers',
  preferencesUnavailable: 'These settings could not be loaded. Your other account settings are available.',
  opinions: 'Opinions', account: 'Account', edit: 'Edit {{label}}', saved: 'Saved',
  confirmExit: 'Log out on this device?', confirmExitAll: 'Log out on all devices?',
  confirmHide: 'Hide all your opinions? They will still count in statistics.',
  confirmClear: 'Clear all your opinions and comments? This action cannot be undone here.',
  confirmDelete: 'Delete your account? Your profile will no longer be available.',
  aboutYou: 'About you',
  noActivity: 'Your opinions will appear here',
  noPublicOpinions: 'No public opinions yet',
};
const ru = {
  username: 'Имя пользователя', name: 'Имя', photo: 'Фото', language: 'Язык', location: 'Местоположение',
  country: 'Страна', chooseCountry: 'Выберите страну',
  useLocation: 'Определить моё местоположение', locating: 'Определяем местоположение…',
  locationDenied: 'Доступ к геолокации запрещён. Выберите страну из списка.',
  locationUnavailable: 'Не удалось определить ваше местоположение. Выберите страну из списка.',
  locationNotFound: 'Не удалось определить страну по вашему местоположению. Выберите её из списка.',
  countrySearch: 'Найти страну', noCountries: 'Страны не найдены',
  notifications: 'Уведомления', likes: 'Лайки', reposts: 'Репосты', subscriptions: 'Новые подписчики',
  preferencesUnavailable: 'Не удалось загрузить эти настройки. Остальные настройки аккаунта доступны.',
  opinions: 'Мнения', account: 'Аккаунт', edit: 'Изменить: {{label}}', saved: 'Сохранено',
  confirmExit: 'Выйти на этом устройстве?', confirmExitAll: 'Выйти на всех устройствах?',
  confirmHide: 'Скрыть все ваши мнения? Они по-прежнему будут учитываться в статистике.',
  confirmClear: 'Удалить все ваши мнения и комментарии? Здесь это действие нельзя отменить.',
  confirmDelete: 'Удалить аккаунт? Ваш профиль больше не будет доступен.',
  aboutYou: 'О вас',
  noActivity: 'Здесь появятся ваши мнения',
  noPublicOpinions: 'Пока нет публичных мнений',
};
const es = {
  username: 'Nombre de usuario', name: 'Nombre', photo: 'Foto', language: 'Idioma', location: 'Ubicación',
  country: 'País', chooseCountry: 'Elige un país',
  useLocation: 'Usar mi ubicación', locating: 'Determinando la ubicación…',
  locationDenied: 'No se ha permitido el acceso a la ubicación. Elige un país de la lista.',
  locationUnavailable: 'No se pudo determinar tu ubicación. Elige un país de la lista.',
  locationNotFound: 'No se pudo determinar el país en esta ubicación. Elige uno de la lista.',
  countrySearch: 'Buscar un país', noCountries: 'No se encontraron países',
  notifications: 'Notificaciones', likes: 'Me gusta', reposts: 'Republicaciones', subscriptions: 'Nuevos seguidores',
  preferencesUnavailable: 'No se pudieron cargar estos ajustes. Los demás ajustes de tu cuenta están disponibles.',
  opinions: 'Opiniones', account: 'Cuenta', edit: 'Editar: {{label}}', saved: 'Guardado',
  confirmExit: '¿Cerrar sesión en este dispositivo?', confirmExitAll: '¿Cerrar sesión en todos los dispositivos?',
  confirmHide: '¿Ocultar todas tus opiniones? Seguirán contando en las estadísticas.',
  confirmClear: '¿Borrar todas tus opiniones y comentarios? Esta acción no se puede deshacer aquí.',
  confirmDelete: '¿Eliminar tu cuenta? Tu perfil dejará de estar disponible.',
  aboutYou: 'Acerca de ti',
  noActivity: 'Tus opiniones aparecerán aquí',
  noPublicOpinions: 'Aún no hay opiniones públicas',
};
const fr = {
  username: 'Nom d’utilisateur', name: 'Nom', photo: 'Photo', language: 'Langue', location: 'Localisation',
  country: 'Pays', chooseCountry: 'Choisissez un pays',
  useLocation: 'Utiliser ma position', locating: 'Localisation en cours…',
  locationDenied: 'L’accès à votre position est refusé. Choisissez un pays dans la liste.',
  locationUnavailable: 'Impossible de déterminer votre position. Choisissez un pays dans la liste.',
  locationNotFound: 'Impossible de déterminer le pays à cet endroit. Choisissez-en un dans la liste.',
  countrySearch: 'Rechercher un pays', noCountries: 'Aucun pays trouvé',
  notifications: 'Notifications', likes: 'J’aime', reposts: 'Republications', subscriptions: 'Nouveaux abonnés',
  preferencesUnavailable: 'Impossible de charger ces paramètres. Les autres paramètres de votre compte restent disponibles.',
  opinions: 'Opinions', account: 'Compte', edit: 'Modifier : {{label}}', saved: 'Enregistré',
  confirmExit: 'Se déconnecter sur cet appareil ?', confirmExitAll: 'Se déconnecter sur tous les appareils ?',
  confirmHide: 'Masquer toutes vos opinions ? Elles resteront prises en compte dans les statistiques.',
  confirmClear: 'Effacer toutes vos opinions et tous vos commentaires ? Cette action ne peut pas être annulée ici.',
  confirmDelete: 'Supprimer votre compte ? Votre profil ne sera plus disponible.',
  aboutYou: 'À propos de vous',
  noActivity: 'Vos opinions apparaîtront ici',
  noPublicOpinions: 'Aucune opinion publique pour le moment',
};
const ja = {
  username: 'ユーザー名', name: '名前', photo: '写真', language: '言語', location: '所在地',
  country: '国', chooseCountry: '国を選択',
  useLocation: '現在地を使用', locating: '現在地を確認中…',
  locationDenied: '位置情報へのアクセスが許可されていません。一覧から国を選択してください。',
  locationUnavailable: '現在地を確認できませんでした。一覧から国を選択してください。',
  locationNotFound: '現在地の国を特定できませんでした。一覧から国を選択してください。',
  countrySearch: '国を検索', noCountries: '該当する国がありません',
  notifications: '通知', likes: 'いいね', reposts: 'リポスト', subscriptions: '新しいフォロワー',
  preferencesUnavailable: 'これらの設定を読み込めませんでした。他のアカウント設定は利用できます。',
  opinions: '意見', account: 'アカウント', edit: '{{label}}を編集', saved: '保存しました',
  confirmExit: 'この端末からログアウトしますか？', confirmExitAll: 'すべての端末からログアウトしますか？',
  confirmHide: '自分の意見をすべて非表示にしますか？統計には引き続き反映されます。',
  confirmClear: '自分の意見とコメントをすべて削除しますか？ここではこの操作を取り消せません。',
  confirmDelete: 'アカウントを削除しますか？プロフィールは利用できなくなります。',
  aboutYou: 'あなたについて',
  noActivity: 'あなたの意見はここに表示されます',
  noPublicOpinions: '公開された意見はまだありません',
};
const ko = {
  username: '사용자 이름', name: '이름', photo: '사진', language: '언어', location: '위치',
  country: '국가', chooseCountry: '국가 선택',
  useLocation: '내 위치 사용', locating: '위치 확인 중…',
  locationDenied: '위치 접근이 허용되지 않았습니다. 목록에서 국가를 선택해 주세요.',
  locationUnavailable: '현재 위치를 확인하지 못했습니다. 목록에서 국가를 선택해 주세요.',
  locationNotFound: '현재 위치한 국가를 확인하지 못했습니다. 목록에서 국가를 선택해 주세요.',
  countrySearch: '국가 검색', noCountries: '검색된 국가가 없습니다',
  notifications: '알림', likes: '좋아요', reposts: '재게시', subscriptions: '새 팔로워',
  preferencesUnavailable: '이 설정을 불러오지 못했습니다. 다른 계정 설정은 이용할 수 있습니다.',
  opinions: '의견', account: '계정', edit: '{{label}} 수정', saved: '저장됨',
  confirmExit: '이 기기에서 로그아웃할까요?', confirmExitAll: '모든 기기에서 로그아웃할까요?',
  confirmHide: '내 의견을 모두 숨길까요? 통계에는 계속 반영됩니다.',
  confirmClear: '내 의견과 댓글을 모두 삭제할까요? 여기서는 이 작업을 되돌릴 수 없습니다.',
  confirmDelete: '계정을 삭제할까요? 프로필을 더 이상 이용할 수 없게 됩니다.',
  aboutYou: '자기소개',
  noActivity: '내 의견이 여기에 표시됩니다',
  noPublicOpinions: '아직 공개된 의견이 없습니다',
};
const pt = {
  username: 'Nome de usuário', name: 'Nome', photo: 'Foto', language: 'Idioma', location: 'Localização',
  country: 'País', chooseCountry: 'Escolha um país',
  useLocation: 'Usar minha localização', locating: 'Determinando a localização…',
  locationDenied: 'O acesso à localização foi negado. Escolha um país da lista.',
  locationUnavailable: 'Não foi possível determinar sua localização. Escolha um país da lista.',
  locationNotFound: 'Não foi possível determinar o país neste local. Escolha um da lista.',
  countrySearch: 'Buscar um país', noCountries: 'Nenhum país encontrado',
  notifications: 'Notificações', likes: 'Curtidas', reposts: 'Republicações', subscriptions: 'Novos seguidores',
  preferencesUnavailable: 'Não foi possível carregar estas configurações. As outras configurações da sua conta estão disponíveis.',
  opinions: 'Opiniões', account: 'Conta', edit: 'Editar: {{label}}', saved: 'Salvo',
  confirmExit: 'Sair da conta neste dispositivo?', confirmExitAll: 'Sair da conta em todos os dispositivos?',
  confirmHide: 'Ocultar todas as suas opiniões? Elas continuarão sendo contabilizadas nas estatísticas.',
  confirmClear: 'Apagar todas as suas opiniões e comentários? Esta ação não pode ser desfeita aqui.',
  confirmDelete: 'Excluir sua conta? Seu perfil não estará mais disponível.',
  aboutYou: 'Sobre você',
  noActivity: 'Suas opiniões aparecerão aqui',
  noPublicOpinions: 'Ainda não há opiniões públicas',
};
const tr = {
  username: 'Kullanıcı adı', name: 'Ad', photo: 'Fotoğraf', language: 'Dil', location: 'Konum',
  country: 'Ülke', chooseCountry: 'Ülke seçin',
  useLocation: 'Konumumu kullan', locating: 'Konum belirleniyor…',
  locationDenied: 'Konum erişimine izin verilmedi. Listeden bir ülke seçin.',
  locationUnavailable: 'Konumunuz belirlenemedi. Listeden bir ülke seçin.',
  locationNotFound: 'Bu konumdaki ülke belirlenemedi. Listeden bir ülke seçin.',
  countrySearch: 'Ülke ara', noCountries: 'Ülke bulunamadı',
  notifications: 'Bildirimler', likes: 'Beğeniler', reposts: 'Yeniden paylaşımlar', subscriptions: 'Yeni takipçiler',
  preferencesUnavailable: 'Bu ayarlar yüklenemedi. Diğer hesap ayarlarınız kullanılabilir durumda.',
  opinions: 'Görüşler', account: 'Hesap', edit: '{{label}} düzenle', saved: 'Kaydedildi',
  confirmExit: 'Bu cihazda oturum kapatılsın mı?', confirmExitAll: 'Tüm cihazlarda oturum kapatılsın mı?',
  confirmHide: 'Tüm görüşleriniz gizlensin mi? İstatistiklere dahil edilmeye devam edecekler.',
  confirmClear: 'Tüm görüşleriniz ve yorumlarınız silinsin mi? Bu işlem burada geri alınamaz.',
  confirmDelete: 'Hesabınız silinsin mi? Profiliniz artık kullanılamayacak.',
  aboutYou: 'Hakkınızda',
  noActivity: 'Görüşleriniz burada görünecek',
  noPublicOpinions: 'Henüz herkese açık görüş yok',
};
const zh = {
  username: '用户名', name: '姓名', photo: '照片', language: '语言', location: '所在地',
  country: '国家', chooseCountry: '选择国家',
  useLocation: '使用我的位置', locating: '正在确定位置…',
  locationDenied: '位置访问权限被拒绝。请从列表中选择国家。',
  locationUnavailable: '无法确定您的位置。请从列表中选择国家。',
  locationNotFound: '无法确定此位置所在的国家。请从列表中选择。',
  countrySearch: '搜索国家', noCountries: '未找到国家',
  notifications: '通知', likes: '赞', reposts: '转发', subscriptions: '新增关注者',
  preferencesUnavailable: '无法加载这些设置。您仍可使用其他账户设置。',
  opinions: '观点', account: '账户', edit: '编辑{{label}}', saved: '已保存',
  confirmExit: '要在此设备上退出登录吗？', confirmExitAll: '要在所有设备上退出登录吗？',
  confirmHide: '要隐藏您的所有观点吗？它们仍会计入统计。',
  confirmClear: '要清除您的所有观点和评论吗？此操作无法在这里撤销。',
  confirmDelete: '要删除账户吗？您的个人资料将不再可用。',
  aboutYou: '关于您',
  noActivity: '您的观点将显示在这里',
  noPublicOpinions: '暂无公开观点',
};
const de = {
  username: 'Benutzername', name: 'Name', photo: 'Foto', language: 'Sprache', location: 'Standort',
  country: 'Land', chooseCountry: 'Land auswählen',
  useLocation: 'Meinen Standort verwenden', locating: 'Standort wird ermittelt…',
  locationDenied: 'Der Standortzugriff wurde verweigert. Wähle ein Land aus der Liste.',
  locationUnavailable: 'Dein Standort konnte nicht ermittelt werden. Wähle ein Land aus der Liste.',
  locationNotFound: 'Das Land an diesem Standort konnte nicht ermittelt werden. Wähle eines aus der Liste.',
  countrySearch: 'Land suchen', noCountries: 'Keine Länder gefunden',
  notifications: 'Benachrichtigungen', likes: 'Gefällt mir', reposts: 'Reposts', subscriptions: 'Neue Follower',
  preferencesUnavailable: 'Diese Einstellungen konnten nicht geladen werden. Deine anderen Kontoeinstellungen sind verfügbar.',
  opinions: 'Meinungen', account: 'Konto', edit: '{{label}} bearbeiten', saved: 'Gespeichert',
  confirmExit: 'Auf diesem Gerät abmelden?', confirmExitAll: 'Auf allen Geräten abmelden?',
  confirmHide: 'Alle deine Meinungen verbergen? Sie werden weiterhin in der Statistik berücksichtigt.',
  confirmClear: 'Alle deine Meinungen und Kommentare löschen? Diese Aktion kann hier nicht rückgängig gemacht werden.',
  confirmDelete: 'Dein Konto löschen? Dein Profil ist danach nicht mehr verfügbar.',
  aboutYou: 'Über dich',
  noActivity: 'Deine Meinungen erscheinen hier',
  noPublicOpinions: 'Noch keine öffentlichen Meinungen',
};
const it = {
  username: 'Nome utente', name: 'Nome', photo: 'Foto', language: 'Lingua', location: 'Posizione',
  country: 'Paese', chooseCountry: 'Scegli un paese',
  useLocation: 'Usa la mia posizione', locating: 'Rilevamento della posizione…',
  locationDenied: 'L’accesso alla posizione è stato negato. Scegli un paese dall’elenco.',
  locationUnavailable: 'Impossibile determinare la tua posizione. Scegli un paese dall’elenco.',
  locationNotFound: 'Impossibile determinare il paese in questa posizione. Scegline uno dall’elenco.',
  countrySearch: 'Cerca un paese', noCountries: 'Nessun paese trovato',
  notifications: 'Notifiche', likes: 'Mi piace', reposts: 'Ripubblicazioni', subscriptions: 'Nuovi follower',
  preferencesUnavailable: 'Impossibile caricare queste impostazioni. Le altre impostazioni del tuo account sono disponibili.',
  opinions: 'Opinioni', account: 'Account', edit: 'Modifica: {{label}}', saved: 'Salvato',
  confirmExit: 'Uscire dall’account su questo dispositivo?', confirmExitAll: 'Uscire dall’account su tutti i dispositivi?',
  confirmHide: 'Nascondere tutte le tue opinioni? Continueranno a essere conteggiate nelle statistiche.',
  confirmClear: 'Cancellare tutte le tue opinioni e i tuoi commenti? Questa azione non può essere annullata qui.',
  confirmDelete: 'Eliminare il tuo account? Il tuo profilo non sarà più disponibile.',
  aboutYou: 'Su di te',
  noActivity: 'Le tue opinioni appariranno qui',
  noPublicOpinions: 'Ancora nessuna opinione pubblica',
};
const hi = {
  username: 'यूज़रनेम', name: 'नाम', photo: 'फ़ोटो', language: 'भाषा', location: 'लोकेशन',
  country: 'देश', chooseCountry: 'देश चुनें',
  useLocation: 'मेरी लोकेशन का उपयोग करें', locating: 'लोकेशन का पता लगाया जा रहा है…',
  locationDenied: 'लोकेशन की अनुमति नहीं है। सूची से देश चुनें।',
  locationUnavailable: 'आपकी लोकेशन का पता नहीं चल सका। सूची से देश चुनें।',
  locationNotFound: 'आपकी लोकेशन से देश का पता नहीं चल सका। सूची से कोई देश चुनें।',
  countrySearch: 'देश खोजें', noCountries: 'कोई देश नहीं मिला',
  notifications: 'सूचनाएँ', likes: 'लाइक', reposts: 'रीपोस्ट', subscriptions: 'नए फ़ॉलोअर',
  preferencesUnavailable: 'ये सेटिंग लोड नहीं हो सकीं। आपके खाते की अन्य सेटिंग उपलब्ध हैं।',
  opinions: 'राय', account: 'खाता', edit: '{{label}} बदलें', saved: 'सहेजा गया',
  confirmExit: 'इस डिवाइस से लॉग आउट करें?', confirmExitAll: 'सभी डिवाइस से लॉग आउट करें?',
  confirmHide: 'अपनी सभी राय छिपाएँ? वे आँकड़ों में गिनी जाती रहेंगी।',
  confirmClear: 'अपनी सभी राय और टिप्पणियाँ हटाएँ? यहाँ इस कार्रवाई को वापस नहीं लिया जा सकता।',
  confirmDelete: 'अपना खाता हटाएँ? आपकी प्रोफ़ाइल फिर उपलब्ध नहीं होगी।',
  aboutYou: 'आपके बारे में',
  noActivity: 'आपकी राय यहाँ दिखाई देंगी',
  noPublicOpinions: 'अभी कोई सार्वजनिक राय नहीं है',
};
const settingsTranslations = { en, ru, es, fr, ja, ko, pt, tr, zh, de, it, hi };
const profileValidationLabels = {
  en: ['Choose a username of 1–64 characters, without spaces or / \\ ? # %. Reserved names are unavailable.', 'Use a name of up to 160 characters without line breaks or control characters.', 'Choose a language from the list.'],
  ru: ['Выберите имя пользователя длиной от 1 до 64 символов без пробелов и / \\ ? # %. Зарезервированные имена недоступны.', 'Имя — до 160 символов, без переносов строк и управляющих символов.', 'Выберите язык из списка.'],
  es: ['Elige un nombre de usuario de 1–64 caracteres, sin espacios ni / \\ ? # %. Los nombres reservados no están disponibles.', 'Usa un nombre de hasta 160 caracteres, sin saltos de línea ni caracteres de control.', 'Elige un idioma de la lista.'],
  fr: ['Choisissez un nom d’utilisateur de 1 à 64 caractères, sans espaces ni / \\ ? # %. Les noms réservés ne sont pas disponibles.', 'Utilisez un nom de 160 caractères maximum, sans saut de ligne ni caractère de contrôle.', 'Choisissez une langue dans la liste.'],
  ja: ['ユーザー名は1～64文字で、空白や / \\ ? # % を含めないでください。予約済みの名前は使えません。', '名前は160文字以内で、改行や制御文字を含めないでください。', 'リストから言語を選択してください。'],
  ko: ['사용자 이름은 공백과 / \\ ? # % 없이 1~64자로 입력하세요. 예약된 이름은 사용할 수 없습니다.', '이름은 줄바꿈이나 제어 문자 없이 160자 이내로 입력하세요.', '목록에서 언어를 선택하세요.'],
  pt: ['Escolha um nome de usuário de 1–64 caracteres, sem espaços nem / \\ ? # %. Nomes reservados não estão disponíveis.', 'Use um nome de até 160 caracteres, sem quebras de linha nem caracteres de controle.', 'Escolha um idioma da lista.'],
  tr: ['Boşluk veya / \\ ? # % içermeyen, 1–64 karakterlik bir kullanıcı adı seçin. Ayrılmış adlar kullanılamaz.', 'Satır sonu veya kontrol karakteri içermeyen, en fazla 160 karakterlik bir ad kullanın.', 'Listeden bir dil seçin.'],
  zh: ['用户名须为 1–64 个字符，不能含空格或 / \\ ? # %。保留名称不可用。', '姓名最多 160 个字符，不能含换行或控制字符。', '请从列表中选择语言。'],
  de: ['Wähle einen Benutzernamen mit 1–64 Zeichen, ohne Leerzeichen oder / \\ ? # %. Reservierte Namen sind nicht verfügbar.', 'Verwende einen Namen mit höchstens 160 Zeichen, ohne Zeilenumbrüche oder Steuerzeichen.', 'Wähle eine Sprache aus der Liste.'],
  it: ['Scegli un nome utente di 1–64 caratteri, senza spazi né / \\ ? # %. I nomi riservati non sono disponibili.', 'Usa un nome di massimo 160 caratteri, senza interruzioni di riga né caratteri di controllo.', 'Scegli una lingua dall’elenco.'],
  hi: ['1–64 वर्णों का यूज़रनेम चुनें, जिसमें स्पेस या / \\ ? # % न हों। आरक्षित नाम उपलब्ध नहीं हैं।', 'नाम अधिकतम 160 वर्णों का हो, जिसमें नई पंक्ति या नियंत्रण वर्ण न हों।', 'सूची से भाषा चुनें।'],
};
for (const [language, [usernameInvalid, nameInvalid, languageInvalid]] of Object.entries(profileValidationLabels)) {
  Object.assign(settingsTranslations[language], { usernameInvalid, nameInvalid, languageInvalid });
}
const opinionStatusLabels = {
  en: ['Hidden opinion', 'Opinion contains blocked content'],
  ru: ['Скрытое мнение', 'В мнении есть заблокированный контент'],
  es: ['Opinión oculta', 'La opinión contiene contenido bloqueado'],
  fr: ['Opinion masquée', 'Cette opinion contient du contenu bloqué'],
  ja: ['非表示の意見', 'この意見にはブロックされた内容が含まれています'],
  ko: ['숨겨진 의견', '차단된 콘텐츠가 포함된 의견'],
  pt: ['Opinião oculta', 'A opinião contém conteúdo bloqueado'],
  tr: ['Gizli görüş', 'Görüş engellenmiş içerik barındırıyor'],
  zh: ['隐藏的观点', '观点包含被屏蔽的内容'],
  de: ['Verborgene Meinung', 'Die Meinung enthält gesperrte Inhalte'],
  it: ['Opinione nascosta', 'L’opinione contiene contenuti bloccati'],
  hi: ['छिपी हुई राय', 'राय में अवरुद्ध सामग्री है'],
};
for (const [language, [hiddenOpinion, blockedOpinionContent]] of Object.entries(opinionStatusLabels)) {
  Object.assign(settingsTranslations[language], { hiddenOpinion, blockedOpinionContent });
}
const makeOpinionPublicLabels = {
  en: 'Make opinion public', ru: 'Сделать мнение публичным', es: 'Hacer pública la opinión',
  fr: 'Rendre l’opinion publique', ja: '意見を公開する', ko: '의견 공개하기',
  pt: 'Tornar a opinião pública', tr: 'Görüşü herkese açık yap', zh: '公开此观点',
  de: 'Meinung öffentlich machen', it: 'Rendi pubblica l’opinione', hi: 'राय सार्वजनिक करें',
};
for (const [language, makeOpinionPublic] of Object.entries(makeOpinionPublicLabels)) {
  Object.assign(settingsTranslations[language], { makeOpinionPublic });
}
export default settingsTranslations;
